{
	"back": "Back",
	"styleNotFound": "Style not found",
	"unableToLoad": "Unable to load style details"
}
